import React from "react";
import "./About.css";

export default function About() {
    return(
        <section id="about">
            <div className="aboutMe">
            <h2>About Me</h2>
            <p>I'm a car enthusiast, Disney fan, and striving to learn more about software development</p>
            <br />
            <hr />
            </div>
            <div className="education">
                <h2>Education</h2>
                <h3>University of Cincinnati</h3>
                <p><em>Associate's of Applied Business: Information Technology</em> • April 2021 GPA: 3.9/4.0</p>
                <br />
                <hr />
            </div>
            <div className="training">
                <h2>Technical Training and Experience</h2>
                <h3>Independent Learning</h3>
                <p>Taking Pluralsight courses in Object Oriented Programming, C#, JavaScript, React and more</p>
                <p>Working on Codecademy courses in HTML, CSS, JavaScript, React and Full-Stack Engineering</p>
                <br />
                <hr />
            </div>
            <div className="workExperience">
                <h2>Work Experience</h2>
                <h3>Target</h3>
                <p><em>Fullfillment Expert</em> • October 2019 - Present</p>
                <br />
                <hr />
            </div>
            <div className="resume-btn">
                <button id="resumeButton" onClick={() => window.open('./Resume.pdf', '_blank')}>Resume</button>
            </div>
        </section>
    );
}